import React from "react";


import amolImg from "../assets/images/amol.jpg";
import harshImg from "../assets/images/harshwardhan.jpg";

import { FaEnvelope, FaLinkedin } from "react-icons/fa";

export default function Experts() {
  return (
    <section className="experts-section" id="experts">

      <div className="section-heading">
        <span>OUR EXPERTS</span>

        <h2>Talk To Our Experts</h2>

        <p>
          Connect with our experienced technology leaders to discuss your
          product idea, software requirements and digital transformation
          journey.
        </p>
      </div>

      <div className="experts-grid">

        {/* Amol */}

        <div className="expert-card">

          <img
            src={amolImg}
            alt="Amol Gomkale"
          />

          <h3>Amol Gomkale</h3>

          <h4>Director, E-Forum Software Solutions</h4>

          <p>
            Enterprise Software Development, Cloud Solutions,
            Product Engineering and Technology Consulting.
          </p>

          <div className="expert-links">

            <a href="mailto:amol.gomkale@eforumsystems.com">
              <FaEnvelope /> Email
            </a>

            <a
              href="https://www.linkedin.com/in/amol-gomkale-7276504"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin /> LinkedIn
            </a>

          </div>

        </div>

        {/* Harshwardhan */}

        <div className="expert-card">

          <img
            src={harshImg}
            alt="Harshwardhan Damle"
          />

          <h3>Harshwardhan Damle</h3>

          <h4>Founder, Opslytic</h4>

          <p>
            Product Strategy, AI Solutions,
            Data Analytics and Digital Transformation.
          </p>

          <div className="expert-links">

            <a href="mailto:harshwardhan.damle@outlook.com">
              <FaEnvelope /> Email
            </a>

            <a
              href="https://www.linkedin.com/in/harshwardhan"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin /> LinkedIn
            </a>

          </div>

        </div>

      </div>

    </section>
  );
}